import config from 'config';
import { getGroupId } from '../AuthToken';

// `isBizzaboInternalWebsiteWhiteLabeled` also matches independent websites, which have no venue proxy.
export const hasWhitelabelVenue = event =>
    event?.websiteType === 'whitelabel' && event?.venueWhitelabel === 'READY';

// Ring's embedded app resolves the event from the first path segment, and its host
// script opens the iframe at `/${data-bz-event-id}/venue/embed.html`. So on a whitelabel
// domain the embed must load from `/<unique-name>/venue`, not from `whitelabelPath`.
export const applyRingEmbedScriptSource = (scriptElement, { eventId, eventUniqueName, isWhitelabel }) => {
    if (isWhitelabel) {
        scriptElement.src = `/${eventUniqueName}/venue/embed.js`;
        scriptElement.setAttribute('data-bz-wl', 'true');
        return;
    }

    scriptElement.src = `/auth/transfer/embed?eventId=${eventId}&groupId=${getGroupId()}&redirectUrl=${config.ringUrl}/embed.js`;
};
